export const PAYMENTS_TOGGLE_TEST_ID = {
  subscriptionButton: 'subscription-button',
  purchaseButton: 'purchase-button',
};
